import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { getMapAccessListFailure, getMapAccessListSuccess } from "domains/createShareSettings/actions";
import type { MapAccessListDefaultAction } from "domains/createShareSettings/actionTypes";
import type { DirectTopicAccessControlGroups } from "domains/topicshare/topicshare.types";

export function* getAccessListSaga(action: MapAccessListDefaultAction) {
  try {
    const topic_id = action.meta.id;
    const response: DirectTopicAccessControlGroups = yield apiFetch(`topic/${topic_id}/access`);
    yield put(getMapAccessListSuccess(response));
  } catch {
    yield put(getMapAccessListFailure(action.meta.id));
  }
}
